// extracted by mini-css-extract-plugin
export default {"substituteSettings":"Substitute_substituteSettings__xK843"};